import { CircularProgress, Stack, Typography } from '@mui/material';

import { StyledSectionDivider } from './style';

export interface SectionHeaderProps {
  title: string;
  count: number;
  isLoading: boolean;
}

export const SectionHeader = ({ title, count, isLoading }: SectionHeaderProps): JSX.Element => (
  <StyledSectionDivider>
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Stack direction="row" spacing={0.5} alignItems="center">
        <Typography color="text.primary" fontWeight={600}>
          {title}
        </Typography>
        {isLoading ? (
          <Typography color="text.tertiary">
            &nbsp;
            <CircularProgress size={12} color="inherit" />
          </Typography>
        ) : (
          <Typography color="text.tertiary">{count}</Typography>
        )}
      </Stack>
    </Stack>
  </StyledSectionDivider>
);
